module.exports = __webpack_public_path__ + "../resources/images/illustration_draft-3887e22c3bfd2f0f8ed08358a078d8fd.svg";